module.exports = __webpack_public_path__ + "static/media/problembg2.9de97514.jpg";